import { lazy } from 'react';
import { IRouteProps } from '../index';

export const route = '/';

const HomepageRoute: IRouteProps = {
  path: route,
  exact: true,
  component: lazy(() => import('./Home')),
  name: 'Home',
};

export default HomepageRoute;
